import { de, type TranslationKey, type Translations } from './de';
import { en } from './en';
import type { Language } from '../platform/settings/settings';

const translations: Readonly<Record<Language, Translations>> = {
  de,
  en,
};

export function translate(language: Language, key: TranslationKey): string {
  return translations[language][key];
}

export { de, en };
export type { TranslationKey, Translations };
